// header height adjustment

(function () {
	const header = document.querySelector('header');
	if (!header) return;

	// Function to update the CSS variable
	function updateHeaderHeight() {
		const height = header.offsetHeight;
		document.documentElement.style.setProperty('--header-height', `${height}px`);
	}

	// Debounce function for performance
	function debounce(func, wait = 100) {
		let timeout;
		return function () {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, arguments), wait);
		};
	}

	// Initial call
	updateHeaderHeight();

	// Update on load and resize (debounced)
	window.addEventListener('load', updateHeaderHeight);
	window.addEventListener('resize', debounce(updateHeaderHeight));

	// Optional: Watch for DOM changes in the header (MutationObserver)
	const observer = new MutationObserver(debounce(updateHeaderHeight));

	observer.observe(header, {
		childList: true, // watch for added/removed nodes
		subtree: true, // watch deeply
		attributes: true, // watch attribute changes (e.g. class change)
		characterData: true, // watch text changes (optional)
	});

	// Optional: Expose function globally for manual updates if needed
	window.updateHeaderHeight = updateHeaderHeight;
})();
